import { TokenSymbol } from '@nsfw-app/crypto'
import { BigNumber } from 'ethers'
import { makeAutoObservable } from 'mobx'
import { RootStore } from './RootStore'

export class ERC20Actions {
  root: RootStore

  constructor(root: RootStore) {
    this.root = root
    makeAutoObservable(this)
  }

  async balanceOf(tokenSymbol: TokenSymbol, address: string): Promise<BigNumber> {
    const contract = await this.root.contracts.getInstance(tokenSymbol)
    return contract.balanceOf(address)
  }
}
